<template>
    <span id="type" style="display: none" v-html="type"></span>
</template>

<script>
export default {
    props: {
        type: String,
        url: String
    },

    async mounted() {
        let loaded = await this.addScript();

        if (loaded) {
            this.generateCart();
        }
    },

    methods: {
        addScript: async function () {
            return new Promise((resolve, reject) => {
                const s = document.createElement('script');
                s.setAttribute('src', this.url);
                s.setAttribute('id', 'payment-page-script');

                s.addEventListener('load', resolve);
                s.addEventListener('error', reject);

                document.getElementById('swedbank-pay-seamless-view-page').appendChild(s);
            });
        },

        generateCart: function () {
            if ($('#swedbank-pay-seamless-view-page')) {
                let typeOfpayment = $('#swedbank-pay-seamless-view-page #type').text();

                if (typeOfpayment === 'kort') {
                    if ($('#payment-page-script').length) {
                        let paymentObject = payex.hostedView.creditCard({
                            // The container specifies which id the script will look for to host the
                            // iframe component.
                            container: 'swedbank-pay-seamless-view-page',
                            onPaymentCompleted: function (paymentCompletedEvent) {
                                window.location.replace(paymentCompletedEvent.redirectUrl);
                            },
                            onPaymentFailed: function (paymentFailedEvent) {
                                // console.log('b',paymentFailedEvent);
                                window.location.replace(window.location.origin + '/transaktion-misslyckad');
                            },
                            // onPaymentCreated: function(paymentCreatedEvent) {
                            //     console.log('c',paymentCreatedEvent);
                            // },
                            // onPaymentToS: function(paymentToSEvent) {
                            //     console.log('d',paymentToSEvent);
                            // },
                            // onPaymentMenuInstrumentSelected: function(paymentMenuInstrumentSelectedEvent) {
                            //     console.log('e',paymentMenuInstrumentSelectedEvent);
                            // },
                            onError: function (error) {
                                // console.error('f',error);
                                window.location.replace(window.location.origin + '/transaktion-misslyckad');
                            }
                        });

                        paymentObject.open();

                        if (!$('body').hasClass('change-payment')) {
                            $('#swedbank-pay-seamless-view-page').append(
                                '<a id="cancel-payment" href="#">Avbryt betalning</a>'
                            );
                        }

                        $(document).on('click', '#cancel-payment', function (e) {
                            e.preventDefault();
                            paymentObject.cancel();
                        });

                        // console.log(paymentObject)
                    }
                } else if (typeOfpayment === 'faktura') {
                    if ($('#payment-page-script').length) {
                        let paymentObject = payex.hostedView.invoice({
                            // The container specifies which id the script will look for to host the
                            // iframe component.
                            container: 'swedbank-pay-seamless-view-page',
                            onPaymentCompleted: function (paymentCompletedEvent) {
                                window.location.replace(paymentCompletedEvent.redirectUrl);
                            },
                            onPaymentFailed: function (paymentFailedEvent) {
                                console.log('b', paymentFailedEvent);
                                window.location.replace(window.location.origin + '/transaktion-misslyckad');
                            },
                            // onPaymentCreated: function(paymentCreatedEvent) {
                            //     console.log('c',paymentCreatedEvent);
                            // },
                            // onPaymentToS: function(paymentToSEvent) {
                            //     console.log('d',paymentToSEvent);
                            // },
                            // onPaymentMenuInstrumentSelected: function(paymentMenuInstrumentSelectedEvent) {
                            //     console.log('e',paymentMenuInstrumentSelectedEvent);
                            // },
                            onError: function (error) {
                                console.error('f', error);
                                window.location.replace(window.location.origin + '/transaktion-misslyckad');
                            }
                        });

                        paymentObject.open();

                        $('#swedbank-pay-seamless-view-page').append(
                            '<a id="cancel-payment" href="#">Avbryt betalning</a>'
                        );

                        $(document).on('click', '#cancel-payment', function (e) {
                            e.preventDefault();
                            paymentObject.cancel();
                        });
                    }
                } else {
                    if ($('#payment-page-script').length) {
                        let paymentObject = payex.hostedView.swish({
                            // The container specifies which id the script will look for to host the
                            // iframe component.
                            container: 'swedbank-pay-seamless-view-page',

                            onPaymentCompleted: function (paymentCompletedEvent) {
                                console.log('a', paymentCompletedEvent);
                                window.location.replace(paymentCompletedEvent.redirectUrl);
                            },

                            onPaymentCanceled: function (paymentCompletedEvent) {
                                console.log('a2', paymentCompletedEvent);
                                // window.location.replace(window.location.origin + '/bli-medlem');
                            },

                            onPaymentFailed: function (paymentFailedEvent) {
                                console.log('b', paymentFailedEvent);
                                // window.location.replace(window.location.origin + '/transaktion-misslyckad');
                            },

                            onPaymentCreated: function (paymentCreatedEvent) {
                                console.log('c', paymentCreatedEvent);
                            },
                            onPaymentToS: function (paymentToSEvent) {
                                console.log('d', paymentToSEvent);
                            },
                            onPaymentMenuInstrumentSelected: function (paymentMenuInstrumentSelectedEvent) {
                                console.log('e', paymentMenuInstrumentSelectedEvent);
                            },
                            onError: function (error) {
                                console.error('f', error);
                                // window.location.replace(window.location.origin + '/transaktion-misslyckad');
                            }
                        });

                        paymentObject.open();

                        $('#swedbank-pay-seamless-view-page').append(
                            '<a id="cancel-payment" href="#">Avbryt betalning</a>'
                        );

                        $(document).on('click', '#cancel-payment', function (e) {
                            e.preventDefault();
                            paymentObject.cancel();
                        });
                    }
                }
            }
        }
    }
};
</script>
